import script from "./UpgradePage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradePage.vue?vue&type=script&setup=true&lang=js"

import "./UpgradePage.vue?vue&type=style&index=0&id=2c41756e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c41756e"]])

export default __exports__